export default "__VITE_ASSET__73d5d54b__"